import Vue from 'vue'
import Router from 'vue-router'

// Containers
import * as Container from '@/f1/containers'
import * as Views from '@/f1/views'

Vue.use(Router)

export default new Router({
  base: "/ui/", // Check vue.config.js
  mode: 'hash', // hash or history
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    { path: '/login', name: 'auth_login', component: Views.Login },
    { path: '/logout', name: 'auth_logout', component: Views.Logout },
    {
      path: '/', redirect: '/dashboard', name: 'Main', component: Container.Private,
      meta: { requiresAuth: true, label: 'Main' },
      children: [
        { path: 'dashboard', name: 'dashboard', meta: { label: 'DashBoard' }, component: Views.Dashboard },

        { path: 'connector', name: 'connector', meta: { label: 'Connector' }, component: { render(c) { return c('router-view'); } }, children: [
          { path: 'ctas/:id?/:tag?', name: 'cti_ctas', meta:{ label: 'C-TAS'}, component:Views.ConnectorCTAS.Base },
          { path: 'webshell/:id?/:tag?', name: 'cti_webshell', meta:{ label: 'Webshell'}, component:Views.ConnectorWebshell.Base },
          // { path: 'analysis/:id?/:tag?', name: 'cti_analysis', meta:{ label: 'Analysis'}, component:Views.CtiAnalysis.Base },
          // { path: 'kisa/:id?/:tag?', name: 'kisa', meta:{ label: 'Kisa Pattern'}, component:Views.CtiKisa.Base },
        ]},

        { path: 'uwss', name: 'uwss', redirect: '/uwss/pattern', meta: { label: 'UWSS' }, component: { render(c) { return c('router-view'); } }, children: [
          { path: 'license/:id?/:tag?', name: 'uwss_license', meta: { label: 'License' }, component: Views.License },
          { path: 'pattern/:id?/:tag?', name: 'uwss_pattern', meta:{ label: 'Pattern'}, component:Views.Pattern },
          { path: 'crs/:id?/:tag?', name: 'uwss_crs', meta:{ label: 'CRS'}, component:Views.CRS },
          { path: 'webshell/:id?/:tag?', name: 'uwss_webshell', meta:{ label: 'Webshell'}, component:Views.Webshell },
        ]},

        { path: 'logs', name: 'log', redirect: '/log/login', meta: { label: 'Log' }, component: { render(c) { return c('router-view'); } }, children: [
          { path: 'login/:id?', name: 'login_log', meta: { label: 'Login' }, component: Views.Logs.Login },
          // { path: 'system/:id?', name: 'system_log', meta: { label: 'System' }, component: Views.Logs.System }, // TODO : 시스템 장애 기록
          { path: 'agent/:id?', name: 'agent_log', meta: { label: 'Agent' }, component: Views.Logs.Agent },
        ]},

        // TODO : SaaS
        // { path: 'boards', name: 'board', meta: { label: 'Board' }, component: { render(c) { return c('router-view'); } }, children: [
        //   { path: 'notice/:id?/:tag?', name: 'notice', meta: { label: 'Notice' }, component: Views.Notice.Base }
        // ]},

        { path: 'system', name: 'system', meta: { label: 'system' }, component: { render(c) { return c('router-view'); } }, children: [
          // { path: 'login/:id?', name: 'login_log', meta: { label: 'Login' }, component: Views.Logs.Login },
          // { path: 'system/:id?', name: 'system_log', meta: { label: 'System' }, component: Views.Logs.System },
          // { path: 'update/:id?', name: 'update_log', meta: { label: 'Update' }, component: Views.Logs.Update },
          // { path: 'fetch/:id?', name: 'fetch_log', meta: { label: 'Fetch' }, component: Views.Logs.Fetch },
          { path: 'user/:id?/:tag?', name: 'user', meta:{ label: 'User'}, component: Views.User.Base },
          { path: 'setting/:id?/:tag?', name: 'setting', meta: { label: 'Setting' }, component: Views.Setting },
        ]},

        { path: 'profile/:tag?', name: 'profile', meta: { label: 'Profile' }, component: Views.Profile },

        // { path: 'wsfinder', name: 'wsfinder', meta: { label: 'WSFinder' }, component: { render(c) { return c('router-view'); } }, children: [
        //   { path: 'webshell/:id?/:tag?', name: 'webshell', meta:{ label: 'Pattern'}, component:Views.WebShell.Base },
        // ]},

        // { path: 'ip/:id?/:tag?', name: 'ip', meta: { label: 'Ip' }, component: Views.Ip },
      ]
    },
    { path: '*', redirect: '/' }
  ]
});

window['views'] = Views
